<template>
  <div class="svg-cont" v-html="src"></div>
</template>

<script>
// let cache = new Map()

export default {
  name: 'SvgInline',
  props: {
    src: { type: String, required: true }
  },
  mounted () {
  }
  // async mounted () {
  //   if (!cache.has(this.src)) {
  //     try {
  //       cache.set(this.src, fetch(this.src).then(r => r.text()))
  //     } catch (e) {
  //       cache.delete(this.src)
  //     }
  //   }
  //   if (cache.has(this.src)) {
  //     const el = await cache.get(this.src)
  //     const domNode = new DOMParser().parseFromString(el, 'text/html').body.childNodes[0]
  //     if (domNode && this.className) {
  //       domNode.classList.add(this.className)
  //     }
  //     this.$el.outerHTML = domNode.outerHTML
  //   }
  // }
}
</script>



// WEBPACK FOOTER //
// src/components/SvgInlineImage.vue